import * as React from 'react';
import { AccordionTrigger, AccordionItem, Accordion, AccordionContent } from '@frontend/shadcn/components/ui/accordion';
import { StarsIcon } from '@revfluence/fresh-icons/regular/esm';
import { TOfferMember } from '@frontend/applications/AffiliatesApp/components/MemberTable/types';
import { FormAsyncAction, IShopifyPromoCodeFormOptions, IShopifyPromoCodeFormValues, OfferFormModes, TDisabledMap, TFormValues } from '../../../types';
import { BoostListing } from './BoostListing';

interface IProps {
  values: TFormValues,
  mode: OfferFormModes,
  onFinish?: () => void,
  requiredFields: React.ReactNode,
  handleFormAsyncActions?: (value: FormAsyncAction) => void,
  formOptionsData?: IShopifyPromoCodeFormOptions,
  isSubscriptionEnable: boolean,
  disabledShopify: TDisabledMap<IShopifyPromoCodeFormValues>;
  offerMembers: TOfferMember[]
}

const Boosts = ({ values, mode, onFinish, requiredFields, handleFormAsyncActions, formOptionsData, isSubscriptionEnable, disabledShopify, offerMembers }: IProps): JSX.Element => {
  return (
    <Accordion type="single" collapsible className="w-full" title="Boosts">
      <AccordionItem value="item-1" className="border-0 m-0">
        <AccordionTrigger className="hover:no-underline p-0 m-0">
          <div className="flex flex-col">
            <p className="text-primary text-base font-medium m-0 flex items-center gap-2">Rewards <StarsIcon className="text-yellow-4" fontSize={16} /></p>
            <p className="text-grey-5 text-xs font-normal m-0">Motivate creators to reach key milestones with performance-based rewards.
            </p>
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <BoostListing values={values} mode={mode} onFinish={onFinish} requiredFields={requiredFields} handleFormAsyncActions={handleFormAsyncActions} formOptionsData={formOptionsData} isSubscriptionEnable={isSubscriptionEnable} disabledShopify={disabledShopify} offerMembers={offerMembers} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default Boosts;
